import React from 'react';
import ReactDOM from 'react-dom/client';
import App, { GlobalErrorBoundary } from './App';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <GlobalErrorBoundary>
      <App />
    </GlobalErrorBoundary>
  </React.StrictMode>
);